// Tiny IndexedDB key-value store for offline drafts & the submission outbox.
const DB_NAME = "hakina-offline";
const STORE = "kv";

const open = () =>
  new Promise((res, rej) => {
    const r = indexedDB.open(DB_NAME, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE);
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });

const tx = async (mode, fn) => {
  const db = await open();
  try {
    return await new Promise((res, rej) => {
      const t = db.transaction(STORE, mode);
      const store = t.objectStore(STORE);
      const req = fn(store);
      t.oncomplete = () => res(req?.result);
      t.onerror = () => rej(t.error);
    });
  } finally {
    db.close();
  }
};

export const idbGet = (key) => tx("readonly", (s) => s.get(key));
export const idbSet = (key, value) => tx("readwrite", (s) => s.put(value, key));
export const idbDel = (key) => tx("readwrite", (s) => s.delete(key));
export const idbKeys = () => tx("readonly", (s) => s.getAllKeys());
export const idbClear = () => tx("readwrite", (s) => s.clear());
